import { render } from "./RejectedPayments.vue?vue&type=template&id=2119bfcc"
import script from "./RejectedPayments.vue?vue&type=script&lang=js"
export * from "./RejectedPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__